import { render, staticRenderFns } from "./CmgMealBuilderItemSelector.vue?vue&type=template&id=084dfb02&scoped=true&lang=pug&"
import script from "./cmg-meal-builder-item-selector.ts?vue&type=script&lang=ts&"
export * from "./cmg-meal-builder-item-selector.ts?vue&type=script&lang=ts&"
import style0 from "./CmgMealBuilderItemSelector.vue?vue&type=style&index=0&id=084dfb02&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "084dfb02",
  null
  
)

export default component.exports